import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerConfig, DatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl, CheckboxControlValueAccessor, ValidatorFn, ValidationErrors } from '@angular/forms';
import {

  CalendarEvent,
  CalendarEventTimesChangedEvent,
} from 'angular-calendar';
import { colors } from 'src/utils/colors';
import { addHours, min, startOfDay } from 'date-fns';
import { TableUsers } from 'src/app/Components/Back-end/day-view-scheduler/day-view-scheduler.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subject } from 'rxjs';

import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import { Location } from '@angular/common';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { User } from 'src/app/Model/User/user.model';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { browserRefresh } from 'src/app/app.component';
import { utc } from 'moment';

import { speedDialFabAnimations } from 'src/app/Components/speed-dial-fab.animations';
import { animation } from '@angular/animations';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';


const tableusers: TableUsers[] = [];/**[
 {
    id: 1,
    userID: 'jahsan',
    fullName: 'John smith',
    color: colors.yellow,
    appointment:'',
  },
  {
    id: 0,
    userID: 'zcannarozzo',
    fullName: 'Jane Doe',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 2,
    userID: 'nsalazar',
    fullName: 'Nicolas',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 3,
    userID: 'sarango',
    fullName: 'Sandra',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 4,
    userID: 'nventura',
    fullName: 'Nancy',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 5,
    userID: 'tkizito',
    fullName: 'Tom',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 6,
    userID: 'rli',
    fullName: 'Ryan',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 7,
    userID: 'jsmith',
    fullName: 'John Smith',
    color: colors.blue,
    appointment:'',
  },
  {
    id: 6,
    userID: 'jdoe',
    fullName: 'Jane',
    color: colors.green,
    appointment:'',
  }
];
**/

interface Appointment extends TableUsers {
  userID: string;
  fullName: string;
  timeIn: string;
  timeOut: string;
  pid: string;
  phoneNumber: string;
  branch: string;
  salesRep: string;
  meta: any;
  users: TableUsers;

}
//const tableusers : TableUsers[]=null;
@Component({

  selector: 'app-sales-rep-timetable',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sales-rep-timetable.component.html',
  styleUrls: ['./sales-rep-timetable.component.css'],
  animations: speedDialFabAnimations



})






export class SalesRepTimetableComponent implements OnInit {

  datesSelected: NgbDateStruct[] = [];

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  //_url= 'http://multiinspectionreport.com/reception/api';
  //_url= 'https://test.appointele.com/api';
  //_url= 'https://demo.appointele.com/api';
  _url = 'https://ciot.appointele.com/api';
  //_url= 'https://ciot.appointele.ca/api';

  //timpicker default time
  time = { hour: 12, minute: 0 };
  meridian = true;

  SalesRepAvailabilityModal: NgbModal;
  fabButtons = [
    {
      icon: 'date_range',
      click: 'getFabButtonOption("btn.click")',
      title: "Sales Rep Availability"
    },
    {
      icon: 'contacts',
      title: "Client Search"
    },
    {
      icon: 'autorenew',
      title: 'Browsing Assignment'
    },/**,
    {
      icon: 'room'
    },
    {
      icon: 'lightbulb_outline'
    },
    {
      icon: 'lock'
    }**/
  ];
  finalbrowsingsalesrep;
  finalbrowsingsalesrepindex;
  allbrowsingappointmentfortoday;
  alltodaysappointment = [];

  browsingSalesReplist;
  arrangedSalesRep;
  buttons = [];
  fabTogglerState = 'inactive';
  clientSearchList: any = [];

  tablerequestTypearray;
  salesrepfreetime;
  tablefreenextarray;
  salesrepfreenext: any = [];

  searchText;
  salesReplist;
  mainSalesReplist;
  reparray = [];
  OffMessage;
  repobj = [];

  lunchreparray = [];
  dayoffreparray = [];
  searchForm: FormGroup;
  clientSearchForm: FormGroup;
  dayoffForm: FormGroup;
  blockoffdayForm: FormGroup;
  lunchForm: FormGroup;
  assignSalesRepBrowsingForm: FormGroup;
  items: Array<CalendarEvent<{ user: TableUsers, phoneNumber: string }>> = [];
  salesRep: TableUsers[];
  viewDate = new Date();
  color;
  tableusers = tableusers;
  username;
  branch;
  role;
  success;
  allappointment = [];
  allappointmentarray = [];
  events: CalendarEvent[];
  currentUser: User;
  error;
  loggedInUsername
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUserId;

  datePickerConfig: Partial<BsDatepickerConfig>;
  newdates = [];

  refresh: Subject<any> = new Subject();

  validationMessages = {
    'salesRep': {
      'required': 'required',

    },
    'dayoffDate': {
      'required': 'required',
    },
    'blockoffDaytimeIn': {
      'required': 'required',
    },
    'blockoffDaytimeOut': {
      'required': 'required',
    },
    'requestType': {
      'required': 'required',
    },

  };


  formErrors = {
    'salesRep': '',
    'dayoffDate': '',
    'blockoffDaytimeIn': '',
    'blockoffDaytimeOut': '',
    'requestType': '',


  };

  requestTypeList = ['Block Off', 'Meeting', 'Training']
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private _location: Location,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _appointment: AppointmentService,
    private _http: HttpClient,
    private fb: FormBuilder,
    public datepipe: DatePipe) {



    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if (this.currentUser) {
      this.username = this.currentUser.firstName + ' ' + this.currentUser.middleName + ' ' + this.currentUser.lastName;
      this.branch = this.currentUser.branch;
      this.role = this.currentUser.role;

      this.loggedInUsername = this.currentUser.userName;
      this.loggedInUserFullname = this.username;
      this.loggedInUserBranch = this.branch
      this.loggedInUserId = this.currentUser.userName;



    }
    //   this.fetchEvents();
    this.getAllRepsbyBranch(this.branch);


    this.datePickerConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue',
      showWeekNumbers: false,
      minDate: new Date(2010, 0, 1),//Month starts at 0, so January is 0
      maxDate: new Date(2050, 11, 31),
      dateInputFormat: 'YYYY-MM-DD',
      defaultTime: '00:00:00',
      //  value: 'YYYY-MM-DD',
    });




  }




  ngOnInit(): void {
    this.getMainSalesRepList(this.branch);
    this.getSalesRepList(this.branch);
    //this.fetchEvents();


    //this.viewDate = new Date();
    this.refresh.next();

    this.blockoffdayForm = this.fb.group({
      modalMsg: new FormControl(''),
      requestType: new FormControl('', [Validators.required]),
      salesRep: new FormControl('', [Validators.required]),
      fullName: new FormControl(''),
      blockoffDaytimeIn: new FormControl('', [Validators.required]),
      blockoffDaytimeOut: new FormControl('', [Validators.required]),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });



    this.dayoffForm = this.fb.group({
      modalMsg: new FormControl(''),
      salesRep: new FormControl('', [Validators.required]),
      dayOffDates: new FormControl('', [Validators.required]),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });



    this.lunchForm = this.fb.group({
      modalMsg: new FormControl(''),
      salesRep: new FormControl('', [Validators.required]),
      lunchDates: new FormControl('', [Validators.required]),
      lunchTime: new FormControl(''),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });




    this.clientSearchForm = this.fb.group({
      modalMsg: new FormControl(''),
      phone: new FormControl('', [Validators.required]),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });

    this.assignSalesRepBrowsingForm = this.fb.group({
      modalMsg: new FormControl(''),
      pid: new FormControl('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),
      salesRep: new FormControl(''),
      requestType: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });


    this.searchForm = this.fb.group({
      searchPhoneText: new FormControl(''),
    });


    this.lunchForm.patchValue({
      lunchTime: this.time,
    });
  }//End of ngOnInit


  change(value: NgbDateStruct[]) {
    // console.log( this.datesSelected);
    this.datesSelected = value;
    //console.log( this.datesSelected);
  }


  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }
  /********************************************************* */
  clientSearch(phoneNumber) {
    // console.log(phoneNumber)
    this._appointment.searchClient(phoneNumber).subscribe(
      (res) => {
        this.clientSearchList = res;
        //  console.log(this.clientSearchList);

      });
  }

  openFABModal(icon) {
    // console.log(icon);
    if (icon == "date_range") {
      this.salesRepFreeTimeModal();
    }
    else if (icon == "contacts") {
      this.searchClientModal();
    }
    else if (icon == "autorenew") {
      this.getSalesRepFreeForNext30();
      this.getArrangedSalesRepForBrowsing();
      this.getSalesRepFreeTime();


      // console.log(this.salesrepfreetime);
      document.getElementById('openBrowsingAssignmentModalButton').click();
    }
  }
  /********************************************************* */


  salesRepFreeTimeModal() {
    this.getSalesRepFreeTime();
    document.getElementById('openSalesRepAvailabilityModalButton').click();

  }
  /********************************************************* */

  searchClientModal() {
    document.getElementById('openClientSearchModalButton').click();

  }

  openClientDetails(client) {

    this.router.navigate(['../client-details', { extra: client.pid, extra1: client.fullName, extra2: client.phoneNumber, extra3: client.email }], { relativeTo: this.actroute });
  }
  /********************************************************* */

  getSalesRepFreeTime() {
    //console.log(this.branch);
    var qdate = new Date();
    //var qdate=new Date('2022-09-27 12:15:00');
    var queryDate = this.datepipe.transform(qdate, 'yyyy-MM-dd H:mm:s');
    // console.log(queryDate);
    this._appointment.getSalesRepFreeTime(this.branch, queryDate).subscribe(
      (res) => {
        this.salesrepfreetime = res;
        // console.log(this.salesrepfreetime);

        this.tablerequestTypearray = Object.entries(this.salesrepfreetime).map(([key, value]) => {
          const y = { [" "]: key }
          return Object.assign({}, y, value)
        })



        if (this.arrangedSalesRep == null || this.arrangedSalesRep.length == 0) {
          // console.log(this.salesrepfreetime)
          this.repobj = [];
          for (var i = 0; i < Object.keys(this.salesrepfreetime).length; i++) {
            var obj = {};
            // console.log(Object.keys(this.salesrepfreetime)  [i]);
            obj['fullName'] = Object.keys(this.salesrepfreetime)[i];
            obj['count'] = 0;


            this.repobj.push(obj);
          };
          //this.browsingSalesReplist=Object.keys(this.salesrepfreetime);
          // console.log(this.repobj);
          this.browsingSalesReplist = this.repobj;
          // console.log(this.tablerequestTypearray);
          // console.log(Object.keys(this.salesrepfreetime));
        } else {
          this.browsingSalesReplist = this.arrangedSalesRep;
        }
        //  console.log(this.salesreplist);
        /** tablerequestTypearray
        0:
        0: "03:30 pm"
        " ": "Olivia Dobrovich"
        1: "04:00 pm"
        2: "04:30 pm"
        3: "05:00 pm"
        4: "05:30 pm"*/
        //console.log(this.tablerequestTypearray);

        //   const headers=Object.keys(this.tablerequestTypearray[0])
        // console.log(headers)
        var stringversion = JSON.stringify(this.tablerequestTypearray, null, 4);

      },
      (err) => {
        this.error = err;
      }
    );

  }
  /********************************************************* */

  createAptFromFreeTime(salesRep, datetime) {
    // console.log(salesRep);
    const now = Date.now();
    const myFormattedDate = this.datepipe.transform(now, 'longDate');
    // console.log(myFormattedDate);
    var ded = new Date(datetime);
    //var ddd=this.datepipe.transform(ded,'H:mm:ss');
    //var time=new Date(myFormattedDate.setTime(21136)); 
    var finaltime = this.datepipe.transform(myFormattedDate + " " + datetime, 'yyyy-MM-dd H:mm:ss');
    //var finaldate=Date()
    //console.log(finaltime);

    this.router.navigate(['../create-appointment', { extra: salesRep, extra1: finaltime, extra2: this.branch }], { relativeTo: this.actroute });
    this.modalService.dismissAll();
  }

  /********************************************************* */



  backClicked() {
    this._location.back();
  }

  /**this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get_for_timeslot.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
      console.log(results);
      return results.map((appointment: Appointment) => {
       // this.colorForRep(appointment.salesRep);
  
        
   this.allappointmentarray =[{
         
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' '),
          start: new Date(
            appointment.timeIn
          ),
          
          color:colors.blue,
        
          meta: {
            user: this.tableusers[this.tableusers.findIndex(x => x.userID===appointment.userID)],
      },
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
  
  
        }];
      
      });
    })
  );
  console.log(this.allappointmentarray);
      }**/


  // events:CalendarEvent [] ;
  /**events:CalendarEvent [] = [
     {
       title: 'An event',
       //color: users[0].color,
       start: addHours(startOfDay(new Date()), 5),
       meta: {
         user: this.tableusers[this.tableusers.findIndex(x => x.userID==='jsmith')],
       },
       resizable: {
         beforeStart: true,
         afterEnd: true,
       },
       draggable: true,
     },
     {
       title: 'Another event',
       //color: users[1].color,
       start: addHours(startOfDay(new Date()), 2),
       meta: {
         user: tableusers[tableusers.findIndex(x => x.userID==='jahsan')],
       },
       resizable: {
         beforeStart: true,
         afterEnd: true,
       },
       draggable: true,
     },
     {
       title: 'A 3rd event',
       //color: users[0].color,
       start: addHours(startOfDay(new Date()), 8),
       meta: {
         user: tableusers[tableusers.findIndex(x => x.userID==='jahsan')],
       },
       resizable: {
         beforeStart: true,
         afterEnd: true,
       },
       draggable: true,
     },
     {
       title: 'An all day event',
       //color: users[0].color,
       start: new Date(),
       meta: {
         user: tableusers[tableusers.findIndex(x => x.userID==='jahsan')],
       },
       draggable: true,
       allDay: true,
     },
     {
       title: 'Another all day event',
       //color: users[1].color,
       start: new Date(),
       meta: {
         user: tableusers[tableusers.findIndex(x => x.userID==='rli')],
       },
       draggable: true,
       allDay: true,
     },
     {
       title: 'A 3rd all day event',
       //color: users[0].color,
       start: new Date(),
       meta: {
         user: tableusers[tableusers.findIndex(x => x.userID==='jahsan')],
       },
       draggable: true,
       allDay: true,
     },
   ];
   **/


  /***************************************************************** */

  getTodaysAppointment() {
    // console.log(this.branch);

    this._appointment.getAllTodaysAppointmentWithoutLunch(this.branch).subscribe(
      (res) => {
        this.alltodaysappointment = res[0];
        // console.log(this.alltodaysappointment);

      },
      (err) => {
        this.error = err;
      }
    );

  }
  /********************************************************* */
  saveSalesRepBrowsingAssignment() {

    //console.log(this.assignSalesRepBrowsingForm)
    //var curposition=+this.browsingSalesReplist.length -1;
    //  moveItemInArray(this.browsingSalesReplist, this.finalbrowsingsalesrepindex, curposition);  
    //  this.updateSalesRepListForBrowsing();
    this._appointment.updateBrowsingAppointmentWithSalesRep(this.assignSalesRepBrowsingForm.value)
      .subscribe(//subscribe to Observable
        response => {
          console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.assignSalesRepBrowsingForm.reset();
          //moveItemInArray(array,previousposition,currentposition);
          var curposition = +this.browsingSalesReplist.length - 1;
          moveItemInArray(this.browsingSalesReplist, this.finalbrowsingsalesrepindex, curposition);
          this.updateSalesRepListForBrowsing();
          this.modalService.dismissAll();
          this.getTodaysAppointment();
          document.getElementById("openSuccessModalButton").click();
          //this.router.navigate(['../main-dashboard'],{relativeTo:this.actroute});
        },
        error => {
          console.error('Error!', error);
          this.error = error.error.text;
        }
      );

  }
  /************************************************************* */
  //updates arranged sales rep list for browsing assignment
  updateSalesRepListForBrowsing() {
    //unshift add to the beginning of array
    this.browsingSalesReplist.unshift(this.loggedInUserBranch);


    this._appointment.updateSalesRepListForBrowsing(this.browsingSalesReplist)
      .subscribe(//subscribe to Observable
        response => {
          console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.getArrangedSalesRepForBrowsing();
          this.getSalesRepFreeTime();
          this.getSalesRepFreeForNext30();
          // document.getElementById("openSuccessModalButton").click();
          this.browsingSalesReplist.shift(this.loggedInUserBranch);
        },
        error => {
          console.error('Error!', error);
          this.error = error.error.text;
          this.browsingSalesReplist.shift(this.loggedInUserBranch);
        }
      );
  }
  /************************************************************* */
  assignSalesRepToBrowsing(rep, index) {
    //console.log(index);
    this.finalbrowsingsalesrep = rep.fullName;
    this.finalbrowsingsalesrepindex = index;
    // moveItemInArray(this.browsingSalesReplist, 1, 0);
    var qdate = new Date();
    var queryDate = this.datepipe.transform(qdate, 'yyyy-MM-dd H:mm:s');
    //console.log(queryDate);
    this.getAllBrowsingAppointmentForToday(this.branch, queryDate);
  }
  drop(event: CdkDragDrop<string[]>) {
    // console.log(event,event.previousIndex, event.currentIndex);
    moveItemInArray(this.browsingSalesReplist, event.previousIndex, event.currentIndex);
    // console.log(this.browsingSalesReplist);
  }

  /*********************************************************** */
  getAllBrowsingAppointmentForToday(branch, queryDate) {
    this._appointment.getAllBrowsingAppointmentForToday(branch, queryDate).subscribe(
      (res) => {
        this.allbrowsingappointmentfortoday = res;
        //console.log(this.allbrowsingappointmentfortoday);
        //closing previous modal
        document.getElementById('openBrowsingAssignmentModalButton').click();

        document.getElementById('openBrowsingListModalButton').click();

      },
      (err) => {
        this.error = err;
      }
    );
  }
  /********************************************************* */
  //gets sales rep that have next 30 min off
  getSalesRepFreeForNext30() {
    //console.log(this.branch);
    var qdate = new Date();
    //var qdate=new Date('2022-09-27 12:15:00');
    //date.setDate(qdate.getDate() -2 );
    //qdate.setHours(qdate.getHours() - 12);
    var queryDate = this.datepipe.transform(qdate, 'yyyy-MM-dd H:mm:s');
    //console.log(queryDate);
    this._appointment.getSalesRepFreeForNext30(this.branch, queryDate).subscribe(
      (res) => {
        this.salesrepfreenext = res;
        //  console.log(this.salesrepfreenext);
        this.salesrepfreenext = Object.keys(this.salesrepfreenext);
        this.tablefreenextarray = Object.entries(this.salesrepfreenext).map(([key, value]) => {
          const y = { [" "]: key }
          return Object.assign({}, y, value)
        })


        //console.log(this.tablefreenextarray);
      },
      (err) => {
        this.error = err;
      }
    );

  }
  /********************************************************* */
  //gets the save instance of sales rep order for browsing assignment
  getArrangedSalesRepForBrowsing() {
    //console.log(this.loggedInUserBranch);
    if (this.loggedInUserBranch != "None" || this.loggedInUserBranch != "") {
      this._appointment.getArrangedSalesRepForBrowsing(this.loggedInUserBranch).subscribe(
        (res) => {
          this.arrangedSalesRep = res;
          ///console.log(this.arrangedSalesRep);


        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }
  }


  /******************************************************************************** */

  openConfirmBrowsingAssignModal(modal, list) {
    document.getElementById('openBrowsingListModalButton').click();
    //document.getElementById('openBrowsingListModalCloseButton').click();

    var finalmessage = "Are you sure you would like make assign this to: "

    //console.log(list);
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });

    this.assignSalesRepBrowsingForm.patchValue({
      modalMsg: finalmessage,
      pid: list.pid,
      branch: this.branch,
      salesRep: this.finalbrowsingsalesrep,
      requestType: "Walk-In",


    });

  }

  /********************************************************* */

  resetBrowsingAssignmentSalesRep() {
    this._appointment.resetArrangedSalesRepForBrowsing(this.loggedInUserBranch).subscribe(
      (res) => {
        this.arrangedSalesRep = res;
        // console.log(this.arrangedSalesRep);
        this.getSalesRepFreeForNext30();
        this.getArrangedSalesRepForBrowsing();
        this.getSalesRepFreeTime();


      }
      ,
      (err) => {
        this.error = err;
      }
    );
  }



  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.events = [...this.events];
  }

  userChanged({ event, newUser }) {
    event.color = newUser.color;
    event.meta.user = newUser;
    this.events = [...this.events];
  }



  eventClicked(event: CalendarEvent<{ users: TableUsers }>): void {
    //console.log(event);
    var mainevent = event['event'];
    var id = mainevent['id'];
    var metaevent = mainevent['meta'];
    // console.log(metaevent['user'].userID)
    // console.log(mainevent['title'])
    if (mainevent['title'] == 'Lunch') {
      this.router.navigate(['../lunch-assignment', { extra: mainevent['id'], extra1: this.datepipe.transform(mainevent['start'], 'yyyy-MM-dd H:mm:ss '), extra2: metaevent['user'].userID, extra3: this.branch, extra4: this.datepipe.transform(mainevent['start'], 'yyyy-MM-dd H:mm:ss ') }], { relativeTo: this.actroute });
    } else {
      //console.log(id);
      this.router.navigate(['../appointment-details', { extra: mainevent['id'], extra1: mainevent['title'], extra2: metaevent['phoneNumber'], extra3: this.branch, extra4: this.datepipe.transform(mainevent['start'], 'yyyy-MM-dd H:mm ', "z-0600") }], { relativeTo: this.actroute });
      // window.open(
      // `https://multiinspectionreport.com/#/appointment-details;extra=${mainevent['id']};extra1=${mainevent['title']};extra2=${metaevent['phoneNumber']}`,

    }

    //  '_blank'
    //)

  }






  getAllRepsbyBranch(branch) {
    // console.log(branch);
    if (branch != "None" || branch != "") {
      this._appointment.getMainSalesRepByBranch(branch).subscribe(
        (res) => {
          this.tableusers = res;
          // console.log(this.tableusers);


          this._appointment.getAllActiveAppointmentForBranchForTimeSlot(branch).subscribe(
            (res) => {
              // console.log(res);
              for (let i = 0; i < res.length; i++) {
                //  console.log(res[i].timeOut)
                if (res[i].requestType == 'Day Off' || res[i].requestType == 'Lunch' || res[i].status == 'Cancelled') {
                  this.color = colors.lightgray;
                } else {
                  this.colorForRep(res[i].salesRep);
                }
                var useridd = this.tableusers.findIndex(x => x.userID == res[i].userID);
                // var timeOut=this.datepipe.transform(new Date(res[i].timeOut), 'yyyy-MM-dd h:mm a');
                if (res[i].timeOut != "" && res[i].timeOut != null) {

                  var timeOut = res[i].timeOut;
                } else {
                  // console.log(res[i].Title);

                  if (res[i].timeIn != null && res[i].timeIn != "") {
                    var timeOute = new Date(res[i].timeIn);
                    var time = new Date(timeOute.setMinutes(timeOute.getMinutes() + 30));
                    timeOut = this.datepipe.transform(time, 'yyyy-MM-dd h:mm a', "z-0600");

                  }
                }
                //      console.log(timeOut);
                // console.log(useridd);
                if (res[i].phoneNumber != "" && res[i].phoneNumber != null) {
                  var phone = ' - ' + res[i].phoneNumber
                } else {
                  var phone = '';
                }
                this.items.push({
                  id: res[i].pid,
                  title: res[i].Title,
                  start: new Date(res[i].timeIn),
                  end: new Date(timeOut),
                  color: this.color,
                  //    end:new Date(new Date(res[i].timeOut).getHours() + 1),
                  meta: {
                    user: this.tableusers[useridd],
                    phoneNumber: res[i].phoneNumber

                  },
                  draggable: false,
                  resizable: {
                    beforeStart: true,
                    afterEnd: true,
                  },
                });
                this.refresh.next();
                //   console.log(this.tableusers.findIndex(x => x.userID==res[i].userID));
              }

              //     console.log(this.items);


            });


          this.refresh.next();
          this.events = this.items;

        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }
  }







  /***************************************************** */

  openLunchModal(modal) {

    this.getSalesRepList(this.branch);
    var finalmessage = "Please select the Sales Representative and the date: "


    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      //myCustomModalClass is in main style.css else it wont work to increase modal width
      windowClass: "myCustomModalClass",
    });

    this.lunchForm.patchValue({
      modalMsg: finalmessage,
      branch: this.branch


    });

  }
  /******************************************************************************** */

  getSalesRep(branch) {
    //  console.log(branch);
    if (branch != "None" || branch != "") {
      this._appointment.getSalesRepByBranch(branch).subscribe(
        (res) => {
          this.salesRep = res;
          //console.log(this.salesRep);


        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }




  }


  saveIndividualBlockoffday() {
    this.logValidationErrors(this.dayoffForm);

    this._appointment.salesrepBlockOffDayAssignment(this.blockoffdayForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.modalService.dismissAll();
          //console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.dayoffForm.reset();
          this.clearData();
          document.getElementById("openSuccesssModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          //console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }

  /*******************************************************************8 */


  saveBlockoffday() {
    this.logValidationErrors(this.dayoffForm);

    this._appointment.multipleSalesrepBlockOffDayAssignment(this.blockoffdayForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.OffMessage = [];
          this.modalService.dismissAll();
          //console.log('Success!', response);
          this.OffMessage = response;
          //console.log(this.OffMessage);
          this.clearData();
          this.blockoffdayForm.reset();
          //console.log(document.getElementById("openOffSuccessModalButton"));
          document.getElementById("openOffSuccessModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          //console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }

  /*******************************************************************8 */


  isChecked(value) {
    // console.log(this.productThicknesses);
    //console.log(value);
    // if(controlName=='thicknesses'){
    //console.log(value,this.thicknessesarray.includes(value))
    for (let i = 0; i < this.reparray.length; i++) {
      // this.schedulearray.forEach(element => {
      //console.log(element['userID']);

      // console.log(i,this.schedulearray[i])
      if (this.reparray[i].userID == value) {
        //  console.log(this.schedulearray[i]['userID'],value);
        return true;
      }
      //return false;


    }

    //  console.log( this.schedulearray.includes(value));

  }

  /************************************************************************* */

  /************************************************************************************** */
  selectSalesRep(event, controlname, value) {
    if (controlname == 'blockOff') {

      // for (let i = 0; i < this.schedulearray.length; i++) {
      //console.log(value);
      //for (let i = 0; i < this.schedulearray.length; i++) {
      //if(this.schedulearray[i].userID==value.userID){
      //  console.log(this.reparray.includes(value));
      //if(this.schedulearray.includes(value)){
      if (this.reparray.some(array => array.userID === value.userID)) {
        // const i=this.schedulearray.indexOf(value)
        const i = this.reparray.findIndex(array => array.userID === value.userID);
        this.reparray.splice(i, 1);

      }

      else {
        this.reparray.push(value);
        //     if(this.removalschedulearray.includes(value)){
        console.log(this.reparray);
      }




      //console.log(this.reparray);
      this.blockoffdayForm.patchValue({
        salesRep: this.reparray
      });

    }
    else
      if (controlname == 'DayOff') {

        // for (let i = 0; i < this.schedulearray.length; i++) {
        //console.log(value);
        //for (let i = 0; i < this.schedulearray.length; i++) {
        //if(this.schedulearray[i].userID==value.userID){
        //  console.log(this.dayoffreparray.includes(value));
        //if(this.schedulearray.includes(value)){
        console.log(this.dayoffreparray);
        if (this.dayoffreparray.some(array => array.userID === value.userID)) {
          // const i=this.schedulearray.indexOf(value)
          const i = this.dayoffreparray.findIndex(array => array.userID === value.userID);
          this.dayoffreparray.splice(i, 1);

        }

        else {
          this.dayoffreparray.push(value);
          //     if(this.removalschedulearray.includes(value)){

        }




        //console.log(this.dayoffreparray);
        this.dayoffForm.patchValue({
          salesRep: this.dayoffreparray
        });

      }

      else

        if (controlname == 'Lunch') {


          // for (let i = 0; i < this.schedulearray.length; i++) {
          //console.log(value);
          //for (let i = 0; i < this.schedulearray.length; i++) {
          //if(this.schedulearray[i].userID==value.userID){
          // console.log(this.lunchreparray.includes(value));
          //if(this.schedulearray.includes(value)){
          if (this.lunchreparray.some(array => array.userID === value.userID)) {
            // const i=this.schedulearray.indexOf(value)
            const i = this.lunchreparray.findIndex(array => array.userID === value.userID);
            this.lunchreparray.splice(i, 1);

          }

          else {
            this.lunchreparray.push(value);
            //     if(this.removalschedulearray.includes(value)){

          }


          //console.log(this.lunchreparray);
          this.lunchForm.patchValue({
            salesRep: this.lunchreparray
          });
        }




  }
  /********************************************************************************************************* */

  saveIndividualDayoff() {
    this.logValidationErrors(this.dayoffForm);

    this._appointment.salesrepDayOffAssignment(this.dayoffForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.modalService.dismissAll();
          //  console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.dayoffForm.reset();
          this.clearData();
          //  console.log(document.getElementById("openOffSuccessModalButton"));
          document.getElementById("openSuccessModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          //  console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }


  /**************************************************************************************************** */

  saveDayoff() {
    this.datesSelected.forEach(value => {
      //console.log(value);
      const nv = value.year + '-' + value.month + '-' + value.day;
      //  console.log(nv);
      if (!this.newdates.includes(nv)) {
        this.newdates.push(nv);
      }
      this.dayoffForm.patchValue({
        dayOffDates: this.newdates,
      });
    });

    this.logValidationErrors(this.dayoffForm);

    //this._appointment.multipleSalesrepDayOffAssignment(this.dayoffForm.value)
    this._appointment.multipleSalesrepWithMultipleDayOffAssignment(this.dayoffForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.OffMessage = [];
          this.modalService.dismissAll();
          // console.log('Success!', response);
          this.OffMessage = response;
          this.dayoffForm.reset();
          console.log(this.dayoffForm.value);
          // console.log( this.OffMessage);
          this.clearData();
          document.getElementById("openOffSuccessModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          // console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }

  /**************************************************************************************************** */
  clearData() {
    this.datesSelected = [];
    this.dayoffreparray = [];
    this.newdates = [];
  }
  /**************************************************************************************************** */

  reload() {
    this.router.navigate(['../sales-rep-timetable'], { relativeTo: this.actroute });
  }

  /***************************************************************************************** */
  openDayOffModal(modal) {

    this.getSalesRepList(this.branch);
    var finalmessage = "Please select the Sales Representative and the date: "


    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      //myCustomModalClass is in main style.css else it wont work to increase modal width
      windowClass: "myCustomModalClass",
    });

    this.dayoffForm.patchValue({
      modalMsg: finalmessage,
      branch: this.branch


    });




  }



  /***************************************************************88 */

  openBlockOffDayModal(modal) {

    this.getSalesRepList(this.branch);
    var finalmessage = "Please select the Sales Representative and the date: "


    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      //myCustomModalClass is in main style.css else it wont work to increase modal width
      windowClass: "myCustomModalClass",
    });

    this.blockoffdayForm.patchValue({
      modalMsg: finalmessage,

      branch: this.branch


    });

  }



  /**************************************************************************************************** */
  /**************************************************************************************************** */
  //OLD WAYS- SAVE LUNCH WITH SINGLE DATE
  saveLunch() {
    this.datesSelected.forEach(value => {
      //console.log(value);
      const nv = value.year + '-' + value.month + '-' + value.day;
      // console.log(nv);
      if (!this.newdates.includes(nv)) {
        this.newdates.push(nv);
      }
      this.lunchForm.patchValue({
        lunchDates: this.newdates,
      });
    });

    // console.log(this.lunchForm);
    this.logValidationErrors(this.lunchForm);

    //this._appointment.multipleSalesrepLunchAssignment(this.lunchForm.value)
    this._appointment.multipleSalesrepWithMultipleDatesLunchAssignment(this.lunchForm.value)
      .subscribe(//subscribe to Observable
        response => {
          this.OffMessage = [];
          this.modalService.dismissAll();
          // console.log('Success!', response);
          this.OffMessage = response;
          this.lunchForm.reset();
          this.clearData();
          document.getElementById("openOffSuccessModalButton").click();
        },
        error => {
          this.modalService.dismissAll();
          // console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );
  }


  /**************************************************************************************************** */

  getSalesRepList(branch) {
    //  console.log(branch);
    if (branch != "None" || branch != "") {
      this._appointment.getSalesRepByBranch(branch).subscribe(
        (res) => {
          this.salesReplist = res;
          //  console.log(this.salesReplist);


        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }

  }

  /**************************************************************************************************** */

  getMainSalesRepList(branch) {
    //  console.log(branch);
    if (branch != "None" || branch != "") {
      this._appointment.getMainSalesRepByBranch(branch).subscribe(
        (res) => {
          this.mainSalesReplist = res;
          // console.log(this.mainSalesReplist);


        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }

  }

  /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  // fetchEvents(): void {
  /**
      const getStart: any = {
        month: startOfMonth,
        week: startOfWeek,
        day: startOfDay,
      }[this.view];
  
      const getEnd: any = {
        month: endOfMonth,
        week: endOfWeek,
        day: endOfDay,
      }[this.view];**/

  /** this.events= this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
    .pipe(
      map(({ results }: { results: Appointment[] }) => {
        console.log(results);
        return results.map((appointment: Appointment) => {
          this.colorForRep(appointment.salesRep);
  
          
           
          return({
              
            title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' '),
            start: new Date(
              appointment.timeIn
            ),
            
            color:colors.blue,
          
            meta: {
           user: this.tableusers[this.tableusers.findIndex(x => x.userID===appointment.userID)],
        },
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
        draggable: true,
  
  
          });
        
        });
      })
    );
  
  
  }
  
  
  /**
  
  dayClicked({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEvent<{ appointment: Appointment }>[];
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  
  }**/


  /**
  eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
    /**window.open(
      `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
      '_blank'
    );**/

  /**
    console.log(event.meta.appointment);
    if(event.meta.appointment.fullName=='Lunch'){
      this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.pid,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRep,extra3:event.meta.appointment.branch}],{relativeTo:this.actroute});
    }else{
   
    this.router.navigate(['../appointment-details', { extra:event.meta.appointment.pid, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch }], { relativeTo: this.actroute });
  }
  }
  **/

  colorForRep(salesRep) {


    if (this.salesReplist.some(array => array.fullName === salesRep)) {
      const i = this.salesReplist.findIndex(array => array.fullName === salesRep);
      //console.log(salesRep);

      // console.log(this.salesReplist[i].color)
      if (this.salesReplist[i].color != null && this.salesReplist[i].color != "") {
        var colour = new String(this.salesReplist[i].color);
        // console.log(this.salesReplist[i].color);
        this.color = { primary: this.salesReplist[i].color, secondary: this.salesReplist[i].color };
      } else if (salesRep == '') {
        this.color = colors.red;
      } else {
        this.color = colors.black;
      }
    }
    /**
    if(salesRep=='Nicolas Salazar'){
      this.color=colors.darkgray;
    }else if(salesRep=='Sonia Garofolo'){
      this.color=colors.yellow;
    } else if(salesRep=='Nancy Ventura'){
      this.color=colors.purple;
    }else if(salesRep=='Olivia Dobrovich'){
      this.color=colors.pink;
    } else if(salesRep=='Jason Branco'){
      this.color=colors.green;
    }else if(salesRep=='Ryan Li'){
      this.color=colors.darkgreen;
    } else if(salesRep=='Caelyn Huang'){
      this.color=colors.purpleblue;
    }else if(salesRep=='Alyssa Vani'){
      this.color=colors.info;
    } else if(salesRep=='Alex Karlee Lafarciola'){
      this.color=colors.brightblue;
    }else if(salesRep=='Magdalena Wojtachnio'){
      this.color=colors.orange;
    } else if(salesRep=='Christelle Aniceto'){
      this.color=colors.lightorange;
    }else if(salesRep=='Zach Cannarozzo'){
      this.color=colors.blue;
    } else if(salesRep=='Alexia Rupolo'){
      this.color=colors.brown;
    }else if(salesRep=='Sandra Arango'){
      this.color=colors.grayblue;
    } else if(salesRep=='Lauren Richardson'){
      this.color=colors.coralred;
    }
    
    
    
     //1020 Lawrence
     else if(salesRep=='Zohaib Salman'){
      this.color=colors.blue;
    } else if(salesRep=='Melissa Hu'){
      this.color=colors.purple;
    } else if(salesRep=='Manal Aziz'){
      this.color=colors.darkgreen;
    } else if(salesRep=='Gianna Cammalleri'){
      this.color=colors.orange;
    } else if(salesRep=='Niki Madarasz'){
      this.color=colors.lightorange;
    } else if(salesRep=='Jacquie Kraizer'){
      this.color=colors.pink;
    }
   **/

    else if (salesRep == '') {
      this.color = colors.red;
    } else {
      this.color = colors.gunmetal;
    }

  }

  /**
   resh(): void {
    window.location.reload();
  }**/




  checkIn() {
    if (this.loggedInUserBranch == '8810JaneSt') {
      this.router.navigate(['../main-signage-dashboard', {}], { relativeTo: this.actroute });
    } else {
      this.router.navigate(['../device-appointment-questionaire', {}], { relativeTo: this.actroute });
    }
  }

  refreshPage() {
    window.location.reload();
  }


  logValidationErrors(group: FormGroup): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
              //console.log(key);


              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }
}

